export const isValidProductLevel = level => {
  return level !== null && level !== undefined && ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'].includes(level);
};
export const isValidPaidProductLevel = level => {
  return level !== null && level !== undefined && ['STARTER', 'PROFESSIONAL', 'ENTERPRISE'].includes(level);
};

// All valid SkuCategoryName string values - this list should match the generated enum exactly
// If a new value is added to SkuCategoryName, TypeScript will error on the assertion below
const ALL_SKU_CATEGORY_NAMES = ['SALES_PRODUCTS', 'ADD_ONS', 'CONSULTING_SERVICE', 'SIDEKICK', 'CLASSROOM_TRAINING_SERVICES', 'OTHER', 'MIGRATION_AND_TEMPLATE_SETUPS', 'ONBOARDING_SERVICES', 'MARKETING_PRODUCTS', 'MARKETING_CONTACTS', 'PREMIER_SERVICES', 'SERVICE_HUB_PRODUCTS', 'CMS_HUB_PRODUCTS', 'OPERATIONS_HUB_PRODUCTS', 'CORE_PLATFORM_SEATS', 'CRM_SUITE', 'MARKETING_PLUS_SUITE', 'BREEZE_PRODUCTS', 'BREEZE_OVERAGE_PRODUCTS', 'HUBSPOT_CREDITS', 'COMMERCE_PRODUCTS'];

// Type assertion that will fail if we're missing any SerializableSkuCategoryName values
// This forces us to update the list above when new enum values are added
// This line will cause a TypeScript error if ALL_SKU_CATEGORY_NAMES is incomplete
const __typeCheck = true;
export const isValidSkuCategoryName = name => {
  return typeof name === 'string' && ALL_SKU_CATEGORY_NAMES.includes(name);
};